import { SUPPLIERS, SUPPLIERS_SUCCESS, SUPPLIERSDETAILS_SUCCESS, SUPPLIERS_ERROR } from './Suppliers.actions'

const initialState = {
  data: [],
  detail: { csvStructure: [], detailList: [], totalAmount: null, totalPO: null },
  error: null,
  fetched: false,
  fetching: false
}

/**
 * Suppliers's reducer.
 */
const suppliersReducer = (state = initialState, { payload, type }) => {
  switch (type) {
    case SUPPLIERS: {
      return { ...state, fetching: true }
    }
    case SUPPLIERS_SUCCESS: {
      return { ...state, data: payload, fetching: false, fetched: true }
    }
    case SUPPLIERSDETAILS_SUCCESS: {
      return { ...state, detail: payload, fetching: false, fetched: true }
    }
    case SUPPLIERS_ERROR: {
      return { ...state, error: payload.error }
    }
    default: {
      return state
    }
  }
}

export default suppliersReducer
